module.exports = __webpack_public_path__ + "static/media/explore-2.7fd608ae.png";